// @flow
import apiRequest from '../../stores/ApiService';
import apiConfig from '../../config';

const getProductSizes = (baseApiUrl: string, storeCode: string) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.product.sizes}?storeCode=${storeCode}`,
  }).then((response) => response.json());

const updateName = (baseApiUrl: string, id: string, projectId: string, name: string) =>
  apiRequest({
    method: 'PUT',
    url: `${baseApiUrl}/${apiConfig.urls.product.index}/${id}/name`,
    body: JSON.stringify({ projectId, name }),
  }).then((response) => response.json());

const updateQuantity = (baseApiUrl: string, projectId: string, id: string, quantity: number) =>
  apiRequest({
    method: 'PUT',
    url: `${baseApiUrl}/${apiConfig.urls.product.index}/${id}/quantity`,
    body: JSON.stringify({ projectId, quantity }),
  }).then((response) => response.json());

export default {
  getProductSizes,
  updateName,
  updateQuantity,
};
